import { StyleSheet, Platform } from 'react-native'

export const landingFooterStyles = StyleSheet.create({
  footer: {
    backgroundColor: '#1A202C',
    paddingHorizontal: 24,
    paddingTop: 64,
    paddingBottom: 40,
  },
  footerStacked: {
    paddingHorizontal: 16,
    paddingTop: 44,
    paddingBottom: 32,
  },
  container: {
    maxWidth: 1240,
    marginHorizontal: 'auto' as unknown as number,
    width: '100%',
  },
  footGrid: {
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    flexWrap: Platform.OS === 'web' ? 'wrap' : undefined,
    gap: 40,
    marginBottom: 48,
    ...(Platform.OS === 'web'
      ? ({
          alignItems: 'flex-start',
          width: '100%' as never,
        } as const)
      : {}),
  },
  /** Narrow marketing layout: must stack vertically on web — row + flex caused overlapping columns (see footer mobile). */
  footGridStacked: {
    flexDirection: 'column',
    flexWrap: 'nowrap' as unknown as 'wrap',
    gap: 26,
    marginBottom: 34,
    ...(Platform.OS === 'web'
      ? ({
          width: '100%' as never,
          alignItems: 'stretch',
        } as const)
      : {}),
  },
  /** Phone: gap alone is unreliable on some mobile browsers; shells add real vertical separation. */
  footGridPhone: {
    gap: 0,
    marginBottom: 30,
    ...(Platform.OS === 'web'
      ? ({
          flexDirection: 'column',
          rowGap: 0,
        } as const)
      : {}),
  },
  footSectionShell: {
    width: '100%' as never,
    flexShrink: 0,
    alignSelf: 'stretch',
    marginBottom: 26,
    ...(Platform.OS === 'web'
      ? ({
          boxSizing: 'border-box',
        } as const)
      : {}),
  },
  footSectionShellLast: {
    marginBottom: 0,
  },
  footBrand: {
    flex: Platform.OS === 'web' ? 2 : undefined,
    minWidth: 200,
  },
  footBrandStacked: {
    minWidth: 0,
    ...(Platform.OS === 'web'
      ? ({
          width: '100%' as never,
          alignSelf: 'stretch',
        } as const)
      : {}),
  },
  footBrandPhone: {
    minWidth: 0,
    flex: 0,
  },
  logoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginBottom: 16,
  },
  logoMark: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: '#6B46C1',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  logoMarkImage: {
    width: 32,
    height: 32,
  },
  logoText: {
    fontFamily:
      Platform.OS === 'web'
        ? '"Space Grotesk", "Inter", system-ui, sans-serif'
        : undefined,
    fontSize: 18,
    fontWeight: '700',
    color: '#FFFFFF',
    letterSpacing: -0.3,
  },
  brandTagline: {
    fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
    fontSize: 14,
    lineHeight: 22,
    color: '#718096',
    marginBottom: 16,
  },
  brandTaglinePhone: {
    fontSize: 13,
    lineHeight: 19,
  },
  socialRow: {
    flexDirection: 'row',
    gap: 8,
  },
  socialBtn: {
    width: 36,
    height: 36,
    borderRadius: 8,
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  socialBtnHovered: {
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
  },
  footCol: {
    flex: Platform.OS === 'web' ? 1 : undefined,
    minWidth: 120,
  },
  footColStacked: {
    minWidth: 0,
    ...(Platform.OS === 'web'
      ? ({
          width: '100%' as never,
          alignSelf: 'stretch',
        } as const)
      : {}),
  },
  footColPhone: {
    flex: 0,
    minWidth: 0,
  },
  footColH4: {
    fontFamily:
      Platform.OS === 'web'
        ? '"Space Grotesk", "Inter", system-ui, sans-serif'
        : undefined,
    fontSize: 13,
    fontWeight: '700',
    color: '#FFFFFF',
    letterSpacing: 0.3,
    textTransform: 'uppercase',
    marginBottom: 16,
  },
  footLink: {
    paddingVertical: 4,
  },
  footLinkText: {
    fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
    fontSize: 14,
    color: '#718096',
  },
  footLinkTextHovered: {
    color: '#FFFFFF',
  },
  divider: {
    height: 1,
    backgroundColor: 'rgba(255,255,255,0.08)',
    marginBottom: 24,
  },
  footBottom: {
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    alignItems: Platform.OS === 'web' ? 'center' : 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
  },
  footBottomStacked: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  footBottomPhone: {
    gap: 12,
  },
  copyright: {
    fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
    fontSize: 13,
    color: '#4A5568',
  },
  copyrightStacked: {
    lineHeight: 19,
  },
  copyrightPhone: {
    fontSize: 12,
  },
  legalLinks: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
    alignItems: 'center',
  },
  legalLinksStacked: {
    gap: 12,
    alignItems: 'flex-start',
  },
  legalLinksPhone: {
    gap: 10,
  },
  legalLink: {
    paddingVertical: 4,
  },
  legalLinkText: {
    fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
    fontSize: 13,
    color: '#4A5568',
  },
  legalLinkTextHovered: {
    color: '#FFFFFF',
  },
})
